var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.576 86.498c-6.854 6.819-17.313 7.864-25.272 3.135l-5.854.306a1.559 1.559 0 0 1-1.642-1.634l.308-5.823c-4.755-7.918-3.705-18.326 3.15-25.145a20.682 20.682 0 0 1 12.351-5.912v-.126h2.087c.145-.002.289-.002.433 0h43.536v13.746H63.466c2.571 7.254.941 15.652-4.89 21.453Z",
    fill: "#000",
    fillOpacity: 0.8,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.738 39.145c10.02 11.206 10.703 27.458 2.602 39.324l-.053 9.16a2.356 2.356 0 0 1-2.621 2.32l-9.15-1.015c-12.789 6.622-28.933 4.054-38.952-7.151-11.834-13.236-10.643-33.51 2.66-45.284 13.303-11.773 33.68-10.589 45.514 2.646ZM51.986 65.046a3.445 3.445 0 0 0 3.454-3.437 3.445 3.445 0 0 0-3.454-3.436 3.445 3.445 0 0 0-3.454 3.436 3.445 3.445 0 0 0 3.454 3.437Zm17.277-3.437a3.445 3.445 0 0 1-3.454 3.437 3.445 3.445 0 0 1-3.455-3.437 3.445 3.445 0 0 1 3.455-3.436 3.445 3.445 0 0 1 3.454 3.436Zm10.353 3.437a3.445 3.445 0 0 0 3.454-3.437 3.445 3.445 0 0 0-3.454-3.436 3.445 3.445 0 0 0-3.454 3.436 3.445 3.445 0 0 0 3.454 3.437Z",
    fill: "#000",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-.001 .499)",
    d: "M0 0h120.002v120.002H0z"
  })))));
};

export default SvgChat;